import axiosClient from "utils/api";
const URI = "/admin/user";
const URA = "/admin";

export const getUser = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get User:", error);
    throw error;
  }
};

export const getActiveUser = async () => {
  const URL = `${URI}/active`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get active User:", error);
    throw error;
  }
};

export const getUserNotification = async (payload) => {
  const URL = `${URI}/userSettings/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user notification:", error);
    throw error;
  }
};

export const getUserLocation = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/userLocation/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user location:", error);
    throw error;
  }
};

export const statusManageUser = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/statusManage/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred status Manage User:", error);
    throw error;
  }
};

export const getUserDetail = async (payload) => {
  const URL = `${URI}/detail/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user detail", error);
    throw error;
  }
};
export const getUserMatches = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/match/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user matches", error);
    throw error;
  }
};

export const profileImageStatus = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/profileStatusManage/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during change status", error);
    throw error;
  }
};

export const getUserReports = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/userReports/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user reports", error);
    throw error;
  }
};

export const getUserGuardians = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URA}/guardian/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user guardians", error);
    throw error;
  }
};

export const getGuardianChilds = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URA}/guardian/childs/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get guardian childs", error);
    throw error;
  }
};
export const getChildKnot = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URA}/guardian/knots/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get guardian childs", error);
    throw error;
  }
};

export const getUserSuggested = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/suggest/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get user guardians", error);
    throw error;
  }
};

export const imageStatusManage = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/imageStatusManage/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during change status", error);
    throw error;
  }
};
